module.exports = __webpack_public_path__ + "img/aquarell_1920_1080_mit_wasserzeichen_22_14.4c2e15cf.jpg";